import axios from "axios";
import API from "@safecv/api";
import toast from "@safecv/shared/toast";
import MESSAGE from "@safecv/shared/message";
import history from "@safecv/shared/history";
import * as actionTypes from "./../Actions/types";
import { PROFILE_PREFERENCE } from "@safecv/shared/appConstant";

export const createFormDataPost = (data, postAddPlan) => (dispatch) => {
  dispatch(actionTypes.fetchNewPostBegin());
  return axios
    .post(API.POSTACTION.UPLOADPROCESSPLAN, data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => {
      dispatch(actionTypes.fetchNewPostSuccess());
      postAddPlan(res);
      toast.success(MESSAGE.postPlanMSG(data.get("planName")));
    })
    .catch((err) => {
      dispatch(actionTypes.fetchNewPostFailure(err));
      if (err.response && err.response.status && err.response.status === 415) {
        toast.error(MESSAGE.ERROR_MESSAGE.ADDPLAN.UPLOAD_FILE);
      } else {
        toast.error(MESSAGE.errorFormDataPost(data.get("planName")));
      }
    });
};

export const uploadGT = (jobId, data) => () => {
  return axios
    .post(API.POSTACTION.GTPLAN(jobId), data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .catch((err) => {
      console.log(err);
    });
};

export const fetchPlanType = (jurisdictionId) => (dispatch) => {
  dispatch(actionTypes.fetchPLantypesBegin());
  axios
    .get(
      API.PLAN_TYPE +
        `?jurisdictionid=${jurisdictionId}&codebookenabled=true&jurisdictionenabled=true`
    )
    .then((res) =>
      dispatch({
        type: actionTypes.PLAN_TYPES,
        payload: {
          planTypes: res.data,
        },
      })
    )
    .catch((err) => {
      console.log(err);
      // toast.error(MESSAGE.ERROR_MESSAGE.GET);
    });
};

export const fetchCodebook = (
  stateId,
  jurisdictionId,
  planTypeId,
  submitDate
) => (dispatch) => {
  dispatch(actionTypes.fetchCodebookBegin());
  axios
    .get(
      API.CODEBOOK +
        `?stateid=${stateId}&jurisdictionid=${jurisdictionId}&plantypeid=${planTypeId}&plansubmitdate=${submitDate}`
    )
    .then((res) => {
      dispatch({
        type: actionTypes.CODEBOOK,
        payload: {
          codebooks: res.data,
        },
      });
    })
    .catch((err) => {
      console.log(err);
      // toast.error(MESSAGE.ERROR_MESSAGE.GET);
    });
};

export const CriteriaList = () => (dispatch) => {
  axios
    .get(API.CRITERIA)
    .then((res) =>
      dispatch({
        type: actionTypes.CRITERIA_FOR_DATATABLE,
        payload: {
          status: res.data.status,
          sourceOfPlan: res.data.sourceOfPlan,
          planTypeFilterData: res.data.planTypes,
        },
      })
    )
    .catch((err) => {
      console.log(err);
      // toast.error(MESSAGE.ERROR_MESSAGE.GET);
    });
};

export const fetchStateList = () => (dispatch) => {
  dispatch(actionTypes.fetchStateListBegin());
  axios
    .get(API.STATES)
    .then((res) =>
      dispatch({
        type: actionTypes.STATES,
        payload: {
          states: res.data,
        },
      })
    )
    .catch((err) => {
      console.log(err);
      // toast.error(MESSAGE.ERROR_MESSAGE.GET);
    });
};

export const fetchJurisdictionList = (state_id) => (dispatch) => {
  dispatch(actionTypes.fetchJurisdictionListBegin());
  axios
    .get(
      API.JURISDICTION +
        `${state_id}?codebookenabled=true&jurisdictionenabled=true&codebookexists=true`
    )
    .then((res) =>
      dispatch({
        type: actionTypes.JURISDICTION,
        payload: {
          jurisdictions: res.data,
        },
      })
    )
    .catch((err) => {
      console.log(err);
      // toast.error(MESSAGE.ERROR_MESSAGE.GET);
    });
};

export const fetchCriteria = () => (dispatch) => {
  dispatch(actionTypes.fetchCriteriaBegin());

  return axios
    .get(API.POSTACTION.DISCIPLINE)
    .then((res) => {
      dispatch(actionTypes.fetchCriteriaSuccess(res));
    })
    .catch((err) => {
      console.log(err);
      dispatch(actionTypes.fetchCriteriaFailure(err));
      // toast.error(MESSAGE.ERROR_MESSAGE.GET);
    });
};

export const postPreference = (data) => (dispatch) => {
  dispatch(actionTypes.postPreferenceBegin());

  return axios
    .post(API.PROFILE.PREFERENCE, data, {
      headers: { "Content-Type": "application/json" },
    })
    .then((res) => {
      localStorage.setItem(PROFILE_PREFERENCE, JSON.stringify(data));

      if (res.status) {
        if (res.status === 200) toast.success(MESSAGE.successPreference());
        else toast.error(MESSAGE.ERROR_MESSAGE.POST);
      }
    })
    .catch((err) => {
      console.log(err);
      //dispatch(actionTypes.postPreferenceFailure(err));
      toast.error(MESSAGE.ERROR_MESSAGE.POST);
    });
};

export const fetchPreference = () => (dispatch) => {
  dispatch(actionTypes.fetchPreferenceBegin());

  return axios
    .get(API.PROFILE.PREFERENCE)
    .then((res) => {
      dispatch(actionTypes.fetchPreferenceSuccess(res));
    })
    .catch((err) => {
      console.log(err);

      // dispatch(actionTypes.fetchPreferenceFailure(err));
      toast.error(MESSAGE.ERROR_MESSAGE.GET);
    });
};

export const filterPlans = (text) => (dispatch) => {
  dispatch(actionTypes.filterplansBegin());

  axios
    .get(API.POSTACTION.PLANS + `/?${text}`)
    .then((res) => {
      dispatch(actionTypes.filterplansSuccess(res, text));
    })
    .catch((err) => {
      toast.error(MESSAGE.ERROR_MESSAGE.FILTER_DATA);
      dispatch(actionTypes.filterplansFailure());
    });
};

export const verficationStatus = (jobId, planName, status, queryParams) => (
  dispatch
) => {
  dispatch(actionTypes.fetchVerificationCompleteBegin());
  return axios
    .put(
      API.VERIFICATION.VERIFIED(jobId, status),
      {},
      {
        params: queryParams,
      }
    )
    .then((res) => {
      dispatch(actionTypes.fetchVerificationCompleteSuccess(res));
      history.push("/plans");
      toast.success(MESSAGE.successVerficationStatus(planName, status));
    })
    .catch((err) => {
      console.log(err);
      dispatch(actionTypes.fetchVerificationCompleteFailure(err));
      toast.error(MESSAGE.errorVerficationStatus(planName));
    });
};

export const fetchDisciplinesByJobId = (jobId, planName) => (dispatch) => {
  dispatch(actionTypes.fetchDisciplinesByJobIdBegin());
  return axios
    .get(API.VERIFICATION.DISCIPLINEBYJOBID(jobId))
    .then((res) => dispatch(actionTypes.fetchDisciplinesByJobIdSuccess(res)))
    .catch((err) => {
      console.log(err);
      dispatch(actionTypes.fetchDisciplinesByJobIdFailure(err));
      toast.error(MESSAGE.errorDisciplinesByJobId(planName));
    });
};

export const fetchVerificationDetailsByJobId = (jobId, planName) => {
  return axios
    .get(API.VERIFICATION.DATES(jobId))
    .then((res) => {
      if (res.status && res.status === 200) return res.data;
      else throw res;
    })
    .catch((err) => {
      console.log(err);
      toast.error(MESSAGE.errorVerificationDetailByJobId());
    });
};

export const fetchVerificationDatesByJobId = (jobId, planName) => (
  dispatch
) => {
  dispatch(actionTypes.fetchVerificationDatesBegin());
  return axios
    .get(API.VERIFICATION.DATES(jobId))
    .then((res) => dispatch(actionTypes.fetchVerificationDatesSuccess(res)))
    .catch((err) => {
      console.log(err);
      dispatch(actionTypes.fetchVerificationDatesFailure(err));
      toast.error(MESSAGE.errorVerificationDatesByJobId(planName));
    });
};

export const fetchVerificationAnnotationByJobId = (jobId, type) => (
  dispatch
) => {
  dispatch(actionTypes.fetchVerificationAnnotationBegin());
  return axios
    .get(API.VERIFICATION.ANNOTATION(jobId, type))
    .then((res) => {
      if (res.data.length === 0) {
        dispatch(actionTypes.fetchVerificationAnnotationNodata());
      } else {
        let data = res.data;
        if (type === "annotated") {
          data.forEach((annotation) => {
            if (annotation.ruleIndex === "UI") annotation.ruleIndex = "Manual";
            if (annotation.ruleNo === "UI") annotation.ruleNo = "Manual";
          });
        }
        dispatch(actionTypes.fetchVerificationAnnotationSuccess(data));
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch(actionTypes.fetchVerificationAnnotationFailure(err));
      // toast.error(MESSAGE.errorVerificationAnnotationByJobId(planName));
    });
};

export const fetchVerificationAnnotationStatsByJobId = (jobId) => (
  dispatch
) => {
  dispatch(actionTypes.fetchVerificationAnnotationStatsBegin());
  return axios
    .get(API.VERIFICATION.ANNOTATIONSTATS(jobId))
    .then((res) => {
      // if (res.data.length === 0) {
      //   dispatch(actionTypes.fetchVerificationAnnotationNodata());
      // } else {
      dispatch(actionTypes.fetchVerificationAnnotationStatsSuccess(res));
      // }
    })
    .catch((err) => {
      console.log(err);
      dispatch(actionTypes.fetchVerificationAnnotationStatsFailure(err));
      // toast.error(MESSAGE.errorVerificationAnnotationByJobId(planName));
    });
};

export const fetchSearchResultsByKeyword = (jobId, keyword) => (dispatch) => {
  if (keyword) {
    dispatch(actionTypes.fetchSearchResultsBegin());
    return axios
      .get(API.VERIFICATION.SEARCH(jobId, keyword))
      .then((res) => dispatch(actionTypes.fetchSearchResultsSuccess(res)))
      .catch((err) => {
        console.log(err);
        dispatch(actionTypes.fetchSearchResultsFailure());
      });
  } else {
    dispatch(actionTypes.fetchSearchResultsFailure());
  }
};

export const fetchAutopopulateResultsByKeyword = (jobId, keyword) => (
  dispatch
) => {
  if (keyword) {
    dispatch(actionTypes.fetchAutopopulateResultsBegin());
    return axios
      .get(API.VERIFICATION.AUTOPOPULATE(jobId, keyword))
      .then((res) => {
        if (res.status && res.status === 200)
          dispatch(actionTypes.fetchAutopopulateResultsSuccess(res));
        else dispatch(actionTypes.fetchAutopopulateResultsFailure());
      })
      .catch((err) => {
        console.log(err);
        dispatch(actionTypes.fetchAutopopulateResultsFailure());
      });
  } else {
    dispatch(actionTypes.fetchAutopopulateResultsFailure());
  }
};

export const fetchFeedbackByJobId = (jobId, type) => (dispatch) => {
  //Avoiding spinner for Feedback
  return axios
    .get(API.FEEDBACK.LIST(jobId, type))
    .then((res) => dispatch(actionTypes.fetchFeedbackSuccess(res)))
    .catch((err) => {
      console.log(err);
      //No error feedback
    });
};

export const addFeedback = (data) => {
  //Not handling error messages for feedback.
  return axios.post(API.FEEDBACK.ADD, data);
};

export const PlansDownload = (jobId) => (dispatch) => {
  dispatch(actionTypes.plansDownloadBegin());
  axios
    .get(API.PDF_DOWNLOAD(jobId))
    .then((res) => dispatch(actionTypes.plansDownloadSuccess(res)))
    .catch((err) => {
      console.log(err);
      toast.error(MESSAGE.errorPlansDownload());
    });
};

export const PDFDownloader = (url) => (dispatch) => {
  dispatch(actionTypes.PDFDownloaderBegin(url));
  return axios({
    url: API.PDF_DOWNLOADER(url),
    method: "GET",
    responseType: "blob",
  })
    .then((response) => {
      if (response.status == 200) {
        dispatch(
          actionTypes.PDFDownloaderSuccess(response.request.responseURL)
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.request.getResponseHeader("X-Suggested-Filename")
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else throw response;
    })
    .catch((err) => {
      console.log(err);
      dispatch(actionTypes.PDFDownloaderFailure(url));
      toast.error(MESSAGE.errorPlansDownload());
    });
};

export const queryParams = (query) => (dispatch) => {
  dispatch({
    type: actionTypes.QUERYPARAMS,
    payload: {
      queryParams: query,
    },
  });
};

export const discardRestoreAnnotation = (
  jobId,
  annotationId,
  type,
  isDiscarded,
  reasonForDiscard
) => (dispatch) => {
  return axios
    .patch(
      API.DISCARD_RESTORE(jobId, annotationId, type),
      [
        {
          op: "replace",
          path: "/discarded",
          value: isDiscarded,
        },
        {
          op: "replace",
          path: "/notes",
          value: reasonForDiscard,
        },
      ],
      {
        headers: { "Content-Type": "application/json-patch+json" },
      }
    )
    .then((res) => {
      if (res.status && res.status === 200) {
        dispatch(
          actionTypes.updateDiscardRestoreAnnotation(
            annotationId,
            isDiscarded,
            reasonForDiscard
          )
        );
        dispatch(fetchVerificationAnnotationStatsByJobId(jobId));
        // dispatch(fetchVerificationAnnotationByJobId(jobId, type));
        toast.success(MESSAGE.discardRestoreMessage(isDiscarded).success);
      } else throw res;
    })
    .catch((err) => {
      console.log(err);
      toast.error(MESSAGE.discardRestoreMessage(isDiscarded).error);
    });
};

export const addAnnotation = (jobId, data, viewType) => (dispatch) => {
  dispatch({ type: actionTypes.ADD_ANNOTATION_BEGUN });
  return axios
    .post(API.ANNOTATION.ADD(jobId), data, {
      headers: { "Content-Type": "text/plain" },
    })
    .then((res) => {
      if (res.status && res.status === 200) {
        dispatch({ type: actionTypes.ADD_ANNOTATION_SUCCESS });
        toast.success(MESSAGE.ADDANNOTATION().SUCCESS);
        dispatch(fetchVerificationAnnotationByJobId(jobId, viewType));
        dispatch(fetchVerificationAnnotationStatsByJobId(jobId));
      } else throw res;
    })
    .catch((err) => {
      toast.error(MESSAGE.ADDANNOTATION().ERROR);
      dispatch({ type: actionTypes.ADD_ANNOTATION_FAILIURE });
    });
};

export const modifyAnnotation = (jobId, data, viewType) => (dispatch) => {
  dispatch({ type: actionTypes.MODIFY_ANNOTATION_BEGUN });
  return axios
    .put(API.ANNOTATION.MODIFY(jobId), data, {
      headers: { "Content-Type": "text/plain" },
    })
    .then((res) => {
      if (res.status && res.status === 200) {
        dispatch({ type: actionTypes.MODIFY_ANNOTATION_SUCCESS });
        toast.success(MESSAGE.MODIFYANNOTATION().SUCCESS);
        dispatch(fetchVerificationAnnotationByJobId(jobId, viewType));
        dispatch(fetchVerificationAnnotationStatsByJobId(jobId));
      } else throw res;
    })
    .catch((err) => {
      toast.error(MESSAGE.MODIFYANNOTATION().ERROR);
      dispatch({ type: actionTypes.MODIFY_ANNOTATION_FAILIURE });
    });
};

export const readAnnotationMessage = (jobId, annotationId, type, value) => (
  dispatch
) => {
  return axios
    .patch(
      API.READ_ANNOTATION(jobId, annotationId, type),
      [
        {
          op: "replace",
          path: "/read",
          value: value,
        },
      ],
      {
        headers: { "Content-Type": "application/json-patch+json" },
      }
    )
    .then((res) => {
      if (res.status == 200) {
        dispatch(actionTypes.updateReadMessage(annotationId, value));
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAnnotationXfdf = (jobId) => {
  return axios
    .get(API.ANNOTATION.GETXFDF(jobId))
    .then((res) => {
      if (res.status && res.status === 200) {
        return res.data;
      } else throw res;
    })
    .catch((err) => {
      toast.error(MESSAGE.GETXFDF);
    });
};

export const getFullAnnotationXfdf = (jobId, outputType) => (dispatch) => {
  dispatch({ type: actionTypes.GET_XFDF_BEGUN });
  axios
    .get(API.ANNOTATION.FULLXFDF(jobId, outputType))
    .then((res) => {
      if (res.status && res.status === 200) {
        dispatch({
          type: actionTypes.GET_XFDF_SUCCESS,
          payload: res.data,
        });
      } else throw res;
    })
    .catch((err) => {
      dispatch({ type: actionTypes.GET_XFDF_FAILIURE });
      toast.error(MESSAGE.GETXFDF);
    });
};

export const postFullAnnotationXfdf = (jobId, outputType, data) => () => {
  return axios
    .post(API.ANNOTATION.FULLXFDF(jobId, outputType), data, {
      headers: { "Content-Type": "text/plain" },
    })
    .then((res) => {
      if (res.status && res.status === 200) {
        // toast.success(MESSAGE.ADDANNOTATION().SUCCESS);
      } else throw res;
    })
    .catch((err) => {
      toast.error(MESSAGE.ADDANNOTATION().ERROR);
    });
};

export const getDesignCriteria = (jobId) => {
  return axios
    .get(API.DESIGN_CRITERIA(jobId))
    .then((res) => {
      if (res?.status === 200) {
        return res.data;
      } else throw res;
    })
    .catch((err) => {
      toast.error(MESSAGE.GETDESIGNCRITERIA);
    });
};

export const updateStampStatus = (jobId, stampPlacement) => {
  return axios
    .put(API.STAMPS.UPDATESTAMPSTATUS(jobId), {
      id: jobId,
      position: stampPlacement,
    })
    .then((res) => {
      if (res?.status === 200) {
        return res;
      } else throw res;
    })
    .catch((err) => {
      toast.error(MESSAGE.UPDATESTAMPSTATUS);
    });
};

export const getStandardStamps = (jobId) => {
  return axios
    .get(API.STAMPS.GETSTAMP(jobId))
    .then((res) => {
      if (res.status && res.status === 200) {
        return res.data;
      } else throw res;
    })
    .catch((err) => {
      toast.error(MESSAGE.GETSTAMP);
    });
};

export const getReconciliationReport = (jobId) => {
  return (dispatch) => {
    dispatch(actionTypes.getReconciliationReportStarted());
    axios
      .get(API.RECONCILIATION_REPORT(jobId))
      .then((res) => {
        if (res?.status === 200) {
          dispatch(actionTypes.getReconciliationReportSuccess(res.data));
        } else throw res;
      })
      .catch((err) => {
        dispatch(actionTypes.getReconciliationReportFailure());
      });
  };
};

export const getDocumentTypes = () => {
  return (dispatch) => {
    axios
      .get(API.DOCUMENT_TYPES)
      .then((res) => {
        if (res?.status === 200) {
          dispatch(actionTypes.getDocumentTypesSuccess(res.data));
        } else throw res;
      })
      .catch((err) => {
        dispatch(actionTypes.getDocumentTypesFailure());
      });
  };
};

export const getCommentLetter = (jobId) => {
  return (dispatch) => {
    dispatch(actionTypes.getCommentLetter());
    axios
      .get(API.COMMENT_LETTER.GET_COMMENT_LETTER(jobId))
      .then((res) => {
        if (res?.status === 200) {
          dispatch(
            actionTypes.getCommentLetterSuccess(
              res.data.commentLetter,
              res.data.id
            )
          );
        } else throw res;
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const saveCommentLetter = (data) => (dispatch) => {
  return axios
    .post(API.COMMENT_LETTER.SAVE_COMMENT_LETTER, data, {
      headers: { "Content-Type": "application/json" },
    })
    .then((res) => {
      if (res.status) {
        if (res.status === 200) toast.success(MESSAGE.COMMENTLETTER().SUCCESS);
        else toast.error(MESSAGE.COMMENTLETTER().ERROR);
      }
    })
    .catch((err) => {
      console.log(err);
      toast.error(MESSAGE.COMMENTLETTER().ERROR);
    });
};

export const getCommentRepoDisciplines = (jobId) => {
  return (dispatch) => {
    dispatch(actionTypes.getCommentRepoDisciplines());
    axios
      .get(API.COMMENT_REPO.GET_DISCIPLINES(jobId))
      .then((res) => {
        if (res?.status === 200) {
          dispatch(actionTypes.getCommentRepoDisciplinesSuccess(res.data));
        } else throw res;
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const saveNeedsInputResponse = (jobId, userResponse, annotationId) => (
  dispatch
) => {
  return axios
    .put(API.NEEDS_INPUT_RESPONSE(jobId), userResponse)
    .then((res) => {
      if (res.status === 200) {
        dispatch({
          type: actionTypes.UPDATE_ANNOTATIONDATA_NEEDSINPUT,
          payload: {
            userResponse: userResponse,
            annotationId: annotationId,
          },
        });
        toast.success(MESSAGE.SAVENEEDSINPUTRESPONSE().SUCCESS);
      } else throw res;
    })
    .catch((err) => {
      toast.error(MESSAGE.SAVENEEDSINPUTRESPONSE().ERROR);
      console.log(err);
    });
};

export const getInitialComments = (data) => {
  return (dispatch) => {
    dispatch(actionTypes.getInitialComments());
    axios
      .get(
        API.COMMENT_REPO.GET_INITIAL_COMMENTS(
          data.allChipFlag,
          data.allCommentSize,
          data.disciplineId,
          data.myCommentsSize,
          data.topCommentsSize
        )
      )
      .then((res) => {
        if (res?.status === 200) {
          dispatch(actionTypes.getInitialCommentsSuccess(res.data));
        } else throw res;
      })
      .catch((err) => {
        dispatch(actionTypes.getInitialCommentsFailure());
        console.log(err);
      });
  };
};

export const searchComments = (data) => {
  return (dispatch) => {
    dispatch(actionTypes.getInitialComments());
    axios
      .get(
        API.COMMENT_REPO.SEARCH_COMMENTS(
          data.allChipFlag,
          data.allCommentSize,
          data.disciplineId,
          data.myCommentsSize,
          data.topCommentsSize,
          data.searchText
        )
      )
      .then((res) => {
        if (res?.status === 200) {
          dispatch(actionTypes.getInitialCommentsSuccess(res.data));
        } else throw res;
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const redirect = (data) => () => {
  if (data) {
    history.push("/plans");
  }
};

export const fetchAdditionalDocuments = (data) => (dispatch) => {
  return axios
    .get(API.VERIFICATION.ADDITIONAL_DOCUMENTS(data))
    .then((res) => {
      if (res.status && res.status === 200) {
        dispatch(actionTypes.getAdditionalDocumentSuccess(res.data));
      } else throw res;
    })
    .catch((err) => {
      console.log(err);
      toast.error(MESSAGE.errorVerificationDetailByJobId());
    });
};

export const getMoreComments = (data) => (dispatch) => {
  dispatch(actionTypes.getMoreCommentsBegin());
  return axios
    .get(
      API.COMMENT_REPO.GET_MORE_COMMENTS(
        data.allChipFlag,
        data.commentsSize,
        data.disciplineId,
        data.id,
        data.section
      )
    )
    .then((res) => {
      if (res.status && res.status === 200) {
        dispatch(actionTypes.getMoreCommentsSuccess(res.data, data.section));
      } else toast.error(MESSAGE.errorFetchMoreComments());
    })
    .catch((err) => {
      console.log(err);
      toast.error(MESSAGE.errorFetchMoreComments());
    });
};

export const getMoreCommentsWithSearch = (data) => (dispatch) => {
  dispatch(actionTypes.getMoreCommentsBegin());
  return axios
    .get(
      API.COMMENT_REPO.GET_MORE_COMMENTS_WITH_SEARCH(
        data.allChipFlag,
        data.commentsSize,
        data.disciplineId,
        data.id,
        data.section,
        data.searchText
      )
    )
    .then((res) => {
      if (res.status && res.status === 200) {
        dispatch(actionTypes.getMoreCommentsSuccess(res.data, data.section));
      } else toast.error(MESSAGE.errorFetchMoreComments());
    })
    .catch((err) => {
      console.log(err);
      toast.error(MESSAGE.errorFetchMoreComments());
    });
};

export const fetchSuggestions = (data) => {
  return (dispatch) => {
    axios
      .get(API.COMMENT_LETTER.FETCH_SUGGESSTIONS(data))
      .then((res) => {
        if (res?.status === 200) {
          dispatch(actionTypes.getSuggestionsSuccess(res.data));
        } else throw res;
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const getEnhancedSearchResults = (jobId) => {
  return axios
    .get(API.ENHANCED_SEARCH(jobId))
    .then((res) => {
      if (res?.status === 200) {
        return res.data;
      } else throw res;
    })
    .catch((err) => {
      toast.error(MESSAGE.GETENHANCEDSEARCHRESULTS);
    });
};

export const clearCommentLetter = () => (dispatch) => {
  dispatch(actionTypes.clearCommentletter());
};

export const favouriteAnnotation = (method, jobId, annotationId) => (
  dispatch
) => {
  return axios({
    method: method,
    url: API.FAVOURITE_ANNOTATION(jobId, annotationId),
  })
    .then((res) => {
      if (res?.status === 200) {
        dispatch({
          type: actionTypes.UPDATE_FAVOURITE_ANNOTATIONS,
          payload: {
            favData: res.data,
          },
        });
        method === "post"
          ? toast.success(MESSAGE.FAVOURITEANNOTATION().ADD)
          : toast.success(MESSAGE.FAVOURITEANNOTATION().DELETE);
      } else throw res;
    })
    .catch((err) => {
      console.log(err);
      toast.error(MESSAGE.FAVOURITEANNOTATION().ERROR);
    });
};

export const fetchFavouriteAnnotation = (jobId) => {
  return axios
    .get(API.GET_FAVOURITE_ANNOTATIONS(jobId))
    .then((res) => {
      if (res?.status === 200) {
        return res.data;
      } else throw res;
    })
    .catch((err) => {
      console.log(err);
      toast.error(MESSAGE.FAVOURITEANNOTATION().FETCH_ERROR);
    });
};
